import axios from 'axios';

import { Toast } from '../component/Toast.js';

/** ----------------------------------------
    Mailchimp
 ---------------------------------------- */

/**
 * The class handles the post request of the
 * newsletter form to subscribe a user to
 * Mailchimp.
 */

export class Mailchimp extends Toast {

    /**
     * @super           set the parent constructor
     * @check           holds the environment class
     * @init            calls the init method
     */

    constructor(host) {
        super();
        this.host = host;
        this.init();
    }

    /** ----------------------------------------
        Click Event
     ---------------------------------------- */

    /**
     * Checks if a newsletter block has been
     * posted and loops through all the inputs
     * and collects the data in a object that
     * is parsed to JSON data. JSON data is
     * posted with axios plugin to the given
     * action of the form.
     */

    postFormEvent() {
        let _this = this;
        let form = document.querySelector('.newsletter-block__form');

        form.addEventListener('submit', function(e) {
            e.preventDefault();

            let obj = {};
            let url = form.action;

            let elements = form.querySelectorAll('input, select, radio, textarea');

            for(let i = 0; i < elements.length; ++i ) {
                let element = elements[i];
                let name = element.name;
                let value = element.value;

                if(element.type === 'radio') {
                    if (name && element.checked) obj['list'] = value;
                    continue;
                }

                if(name) obj[name] = value;
            }

            _this.postData(url, obj);
        });
    }

    /** ----------------------------------------
        Post Data
     ---------------------------------------- */

    /**
     * Will post the data and will set a message
     * based on a given response.
     */

    postData(url, data) {
        let message = '';

        axios.post(url, data)
            .then(result => {
                if(result.data.duplicate)
                    message = this.host.translate('Dit email adres is al ingeschreven', 'This email address is already subscribed');

                if(result.data.success)
                    message = this.host.translate('Je bent nu lid van onze nieuwsbrief!', 'You are now subscribed!');

                this.setToast(message, '');

            })
            .catch(errors => {
               if(errors.response)
                    message = Object.keys(errors.response.data)
                        .map(error => errors.response.data[error]);

                    this.setToast(message, '');
            });
    }

    /** ----------------------------------------
        Init
     ---------------------------------------- */

    init() {
        let newsletter = document.querySelector('.newsletter-block');

        if(!newsletter)
            return;

        this.postFormEvent();
    }

}